import { jsx, jsxs } from "react/jsx-runtime";
import { c } from "react/compiler-runtime";
import { styled } from "@mui/material/styles";
import Box from "@mui/material/Box";
import Skeleton from "@mui/material/Skeleton";
import Typography from "@mui/material/Typography";
import { textSpacer } from "../constants.js";
import TrendIcon from "./Icon.js";
import { formatValue } from "../utils/data.js";
import { getDirection, getTrendClassName, getPercentageSymbol, getRatio } from "../utils/trends.js";
const TrendIconSkeleton = styled(Skeleton)(({
  theme
}) => ({
  width: theme.sizes.spacing["08"],
  height: theme.sizes.spacing["08"],
  marginRight: theme.sizes.spacing["02"]
}));
const TrendTextSkeleton = styled(Skeleton)(({
  theme
}) => ({
  width: theme.sizes.spacing["11"],
  height: theme.sizes.spacing["08"]
}));
const SkeletonWrapper = styled(Box)(({
  theme
}) => ({
  width: "100%",
  display: "flex",
  alignItems: "center",
  flexDirection: "row",
  gap: theme.sizes.spacing["02"],
  padding: `0px ${theme.sizes.spacing["04"]} ${theme.sizes.spacing["02"]} ${theme.sizes.spacing["04"]}`
}));
const TrendWithIconSkeleton = () => {
  const $ = c(1);
  let t0;
  if ($[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel")) {
    t0 = /* @__PURE__ */ jsxs(SkeletonWrapper, { children: [
      /* @__PURE__ */ jsx(TrendIconSkeleton, { variant: "circular" }),
      /* @__PURE__ */ jsx(TrendTextSkeleton, { variant: "text" })
    ] });
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};
const TrendWithIcon = (t0) => {
  const $ = c(25);
  const {
    data,
    isLoading,
    float: t1
  } = t0;
  const float = t1 === void 0 ? "left" : t1;
  if (!data || isLoading) {
    let t22;
    if ($[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel")) {
      t22 = /* @__PURE__ */ jsx(TrendWithIconSkeleton, {});
      $[0] = t22;
    } else {
      t22 = $[0];
    }
    return t22;
  }
  const {
    original,
    comparison,
    desiredTrend
  } = data;
  if (!original || !comparison) {
    let t22;
    if ($[1] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel")) {
      t22 = /* @__PURE__ */ jsx(Box, { children: /* @__PURE__ */ jsx(Typography, { children: textSpacer }) });
      $[1] = t22;
    } else {
      t22 = $[1];
    }
    return t22;
  }
  let direction;
  let directionClass;
  let formattedValue;
  let t2;
  if ($[2] !== comparison || $[3] !== desiredTrend || $[4] !== original) {
    const ratio = getRatio(original, comparison);
    let trend = 0;
    if (ratio > 1) {
      trend = ratio - 1;
    } else {
      if (ratio < 1) {
        trend = 1 - ratio;
      }
    }
    direction = getDirection(ratio);
    if (ratio === 0 && original === 0) {
      direction = 0;
    }
    formattedValue = !direction ? "-" : formatValue(trend, {
      precision: 1,
      short: false,
      type: "percentage"
    });
    directionClass = getTrendClassName(direction, desiredTrend);
    t2 = getPercentageSymbol(direction);
    $[2] = comparison;
    $[3] = desiredTrend;
    $[4] = original;
    $[5] = direction;
    $[6] = directionClass;
    $[7] = formattedValue;
    $[8] = t2;
  } else {
    direction = $[5];
    directionClass = $[6];
    formattedValue = $[7];
    t2 = $[8];
  }
  const percentageSymbol = t2;
  let t3;
  if ($[9] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      width: "100%",
      display: "flex",
      alignItems: "center",
      flexDirection: "row",
      gap: "4px"
    };
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  let t4;
  if ($[10] !== desiredTrend || $[11] !== direction) {
    t4 = /* @__PURE__ */ jsx(TrendIcon, { direction, desiredTrend, size: "sm" });
    $[10] = desiredTrend;
    $[11] = direction;
    $[12] = t4;
  } else {
    t4 = $[12];
  }
  let t5;
  if ($[13] !== float) {
    t5 = {
      float,
      paddingLeft: "0.1rem"
    };
    $[13] = float;
    $[14] = t5;
  } else {
    t5 = $[14];
  }
  const t6 = directionClass;
  const t7 = formattedValue || textSpacer;
  let t8;
  if ($[15] !== percentageSymbol || $[16] !== t6 || $[17] !== t7) {
    t8 = /* @__PURE__ */ jsxs(Typography, { variant: t6, children: [
      percentageSymbol,
      t7
    ] });
    $[15] = percentageSymbol;
    $[16] = t6;
    $[17] = t7;
    $[18] = t8;
  } else {
    t8 = $[18];
  }
  let t9;
  if ($[19] !== t5 || $[20] !== t8) {
    t9 = /* @__PURE__ */ jsx("div", { style: t5, children: t8 });
    $[19] = t5;
    $[20] = t8;
    $[21] = t9;
  } else {
    t9 = $[21];
  }
  let t10;
  if ($[22] !== t4 || $[23] !== t9) {
    t10 = /* @__PURE__ */ jsxs(Box, { sx: t3, children: [
      t4,
      t9
    ] });
    $[22] = t4;
    $[23] = t9;
    $[24] = t10;
  } else {
    t10 = $[24];
  }
  return t10;
};
export {
  TrendWithIcon as default
};
